var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondenserOnHeaterOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Condenser_ON_Heater_ON",
    "data-name": "Condenser ON_Heater ON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 33,
    viewBox: "0 0 91 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9843",
    "data-name": "Group 9843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    d: "M90.35,16.51H86.6V4.59A3.941,3.941,0,0,0,82.66.65H9.27A3.935,3.935,0,0,0,5.33,4.59V16.52H.65v9.21H5.33v2.69a3.941,3.941,0,0,0,3.94,3.94H82.66a3.935,3.935,0,0,0,3.94-3.94V25.73h3.75V16.51Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    d: "M82.66,33H9.27a4.594,4.594,0,0,1-4.59-4.58V26.37H0V15.86H4.68V4.59A4.6,4.6,0,0,1,9.27,0H82.66a4.6,4.6,0,0,1,4.59,4.59V15.87H91V26.38H87.25v2.05A4.592,4.592,0,0,1,82.66,33ZM1.3,25.08H5.98v3.34a3.3,3.3,0,0,0,3.3,3.29H82.67a3.3,3.3,0,0,0,3.3-3.29V25.08h3.75V17.16H85.97V4.59a3.3,3.3,0,0,0-3.3-3.29H9.27a3.3,3.3,0,0,0-3.3,3.29V17.16H1.3Z",
    fill: "#ff5240"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9858",
    "data-name": "Group 9858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9844",
    "data-name": "Group 9844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M26.83,30.19V25.01a2.106,2.106,0,0,0,2.11-2.09v-.43h5.18v.43A7.287,7.287,0,0,1,26.83,30.19Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9845",
    "data-name": "Group 9845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M26.83,30.19a7.287,7.287,0,0,1-7.29-7.27V11.11h5.18V22.92a2.106,2.106,0,0,0,2.11,2.09v5.18Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9846",
    "data-name": "Group 9846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M43.52,11.35H38.34v-.43a2.106,2.106,0,0,0-2.11-2.09V3.65a7.287,7.287,0,0,1,7.29,7.27Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9847",
    "data-name": "Group 9847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M34.12,22.74H28.94V10.92a7.287,7.287,0,0,1,7.29-7.27V8.83a2.106,2.106,0,0,0-2.11,2.09Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9848",
    "data-name": "Group 9848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M45.63,30.19V25.01a2.106,2.106,0,0,0,2.11-2.09v-.43h5.18v.43A7.287,7.287,0,0,1,45.63,30.19Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9849",
    "data-name": "Group 9849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M45.63,30.19a7.287,7.287,0,0,1-7.29-7.27V10.51h5.18V22.92a2.106,2.106,0,0,0,2.11,2.09Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9850",
    "data-name": "Group 9850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M62.32,23.14H57.14V10.92a2.106,2.106,0,0,0-2.11-2.09V3.65a7.287,7.287,0,0,1,7.29,7.27Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9851",
    "data-name": "Group 9851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    d: "M52.92,23.33H47.74V10.92a7.287,7.287,0,0,1,7.29-7.27V8.83a2.106,2.106,0,0,0-2.11,2.09Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9852",
    "data-name": "Group 9852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    d: "M64.43,30.4V25.22a2.106,2.106,0,0,0,2.11-2.09V22.7h5.18v.43A7.287,7.287,0,0,1,64.43,30.4Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9853",
    "data-name": "Group 9853"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    d: "M64.43,30.4a7.287,7.287,0,0,1-7.29-7.27h5.18a2.106,2.106,0,0,0,2.11,2.09Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9854",
    "data-name": "Group 9854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    d: "M81.12,31.43H75.94V11.14a2.106,2.106,0,0,0-2.11-2.09V3.87a7.287,7.287,0,0,1,7.29,7.27Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9855",
    "data-name": "Group 9855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M71.72,23.55H66.54V11.14a7.287,7.287,0,0,1,7.29-7.27V9.05a2.106,2.106,0,0,0-2.11,2.09Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9856",
    "data-name": "Group 9856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3904",
    "data-name": "Path 3904",
    d: "M24.72,11.35H19.54v-.43a2.106,2.106,0,0,0-2.11-2.09V3.65a7.287,7.287,0,0,1,7.29,7.27v.43Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9857",
    "data-name": "Group 9857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    "data-name": "Path 3905",
    d: "M15.32,31.1H10.14V10.92a7.287,7.287,0,0,1,7.29-7.27V8.83a2.106,2.106,0,0,0-2.11,2.09V31.1Z",
    fill: "#00b7ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondenserOnHeaterOn);
export default __webpack_public_path__ + "static/media/condenser_on_heater_on.ea0ff584e3f1f87d373bd1b02801441c.svg";
export { ForwardRef as ReactComponent };